import api from 'app/api';
import { LoginType } from '../types/LoginType';
import { Services } from 'modules/common/enums/Services';

const SERVICE = Services.BACKEND;

export const apiLoginAttempt = async (data: LoginType) => {
	const response = await api.post(SERVICE + '/auth/login', data);

	return response;
};

export const apiLogoutAttempt = async () => {

	const response = await api.post(SERVICE + '/auth/logout');

	return response;
};

export const apiCurrentUser = async () => {
	const response = await api.get(SERVICE + '/user/current');

	return response;
};
export const apiCurrentRoles = async () => {
	const response = await api.get(SERVICE + '/roles/current');

	return response;
};
export const apiCurrentPermissions = async () => {
	const response = await api.get(SERVICE + '/permissions/current');

	return response;
};
export const apiCheckIfAccessTokenActive = async () => {
	const response = await api.get(SERVICE + '/user/current');

	return response;
};
